import { tr } from 'mmfintech-commons'
import { useRef } from 'react'

import './threshold.scss'

const DEFAULT_THRESHOLD = 999999999999

type ThresholdProps = {
  isThresholdEnabled: boolean
  amountThreshold: number | string
  onChange: (value: number | string) => void
  index: number
  setApproversData: (value: any) => void
  currencySymbol: string
}

export const Threshold = ({
  isThresholdEnabled,
  amountThreshold,
  index,
  setApproversData,
  currencySymbol
}: ThresholdProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <>
      {isThresholdEnabled ? (
        <div className='threshold-input-container'>
          <span className='threshold-input-container-title'>
            {tr('FRONTEND.TRANSACTION_MATRIX.UP_TO', 'Up to')} {currencySymbol}
          </span>
          <input
            className='threshold-input'
            ref={inputRef}
            type='number'
            value={amountThreshold || ''}
            max={DEFAULT_THRESHOLD.toString()}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value
              if (value.length <= 6) {
                setApproversData(prev =>
                  prev.map((p, i) =>
                    i === index
                      ? {
                          ...p,
                          amountThreshold: value ? Math.min(Number(value), DEFAULT_THRESHOLD) : ''
                        }
                      : p
                  )
                )
              }
            }}
          />
        </div>
      ) : (
        <button
          type='button'
          className='set-threshold-button'
          onClick={() => {
            setApproversData(prev => prev.map((p, i) => (i <= index ? { ...p, isThresholdEnabled: true } : p)))

            setTimeout(() => {
              inputRef.current?.focus()
            }, 0)
          }}
        >
          <span>{tr('FRONTEND.THRESHOLD.SET_THRESHOLD', 'Set Threshold')}</span>
        </button>
      )}
    </>
  )
}
